export function findLatestBooking(bookings) {
  return bookings.reduce((latest, current) => {
    if (!latest) return current;

    // Combine date and time for full comparison
    const latestDateTime = new Date(
      `${latest.bookingDate}T${latest.bookingStartTime}`
    );
    const currentDateTime = new Date(
      `${current.bookingDate}T${current.bookingStartTime}`
    );

    return currentDateTime > latestDateTime ? current : latest;
  }, null);
}


export function derivedBookingStatus(bookingStatus) {
  if (bookingStatus == 3) {
    return "pending";
  } else if (bookingStatus == 1) {
    return "confirmed";
  } else if (bookingStatus == 3) {
    return "pending";
  } else {
    return "cancelled";
  }
};